<template>
    <div class="Direction__wrapper">
        <div class="Direction">
            <div class="Direction__in">
                <div class="Direction__img">
                    <img :src="data.img" :alt="data.name">
                </div>
                <div class="Direction__name">
                    {{ data.name }}
                </div>
                <div class="Direction__description">
                    {{ data.description }}
                </div>
            </div>
            <a :href="data.url" class="Direction__btn">
                <ABtn label="Подать заявку.." class="primary w-100"/>
            </a>
        </div>
    </div>
</template>

<script>
import {ABtn} from '../ui'

export default {
    name: "Direction",
    props: {
        data: {
            type: Object,
            default: () => {
                return {
                    img: '',
                    title: '',
                    description: '',
                    url: ''
                }
            }
        }
    },
    components: {ABtn}
}
</script>

<style scoped lang="scss">
.Direction {
    width: 100%;
    background: #FFFFFF;
    border-radius: 6px;
    overflow: hidden;

    &:hover {
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
        margin-bottom: -50px;

        .Direction__btn {
            display: block;
        }
    }

    &__wrapper {

    }

    &__in {
        padding: 38px;
    }

    &__img {
        margin-bottom: 42px;
        max-height: 60px;

        img {
            height: 100%;
            max-height: 60px;
            width: 100%;
            object-fit: contain;
            object-position: left;
        }
    }

    &__name {
        font-weight: 600;
        font-size: 22px;
        line-height: 28px;
        margin-bottom: 18px;
    }

    &__description {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: var(--c-secondary-200);
        margin-bottom: 0;
    }

    &__btn {
        display: none;
    }
}

::v-deep .a-btn {
    border-radius: 0;
}
</style>